<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>Login</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form @submit="submitSignInForm" id="loginForm">
                  <v-text-field
                    label="Username"
                    id="username"
                    name="username"
                    autocomplete="username"
                    prepend-icon="mdi-account"
                    type="text"
                    v-model="username"
                    :error-messages="formErrors.username"
                  />

                  <v-text-field
                    id="password"
                    label="Password"
                    name="password"
                    autocomplete="current-password"
                    prepend-icon="mdi-lock"
                    type="password"
                    v-model="password"
                    :error-messages="formErrors.password"
                  />
                  <v-alert
                    v-if="formErrors.non_field_errors"
                    type="error"
                    text
                    dense
                  >
                    {{ formErrors.non_field_errors[0] }}
                  </v-alert>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="primary"
                  type="submit"
                  form="loginForm"
                  :loading="isWaitingForResponse"
                >
                  Login
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  name: "SignIn",

  data: () => ({
    isWaitingForResponse: false,
    formErrors: {},
    username: "",
    password: ""
  }),

  methods: {
    submitSignInForm: function (e) {
      e.preventDefault();
      this.isWaitingForResponse = true;
      const loginData = {
        username: this.username,
        password: this.password
      };
      axios
        .post(`${process.env.VUE_APP_API_ROOT_URL}auth/get-token/`, loginData)
        .then(response => {
          const newAuthToken = `Token ${response.data.token}`
          this.$store.dispatch("setAuthToken", newAuthToken)
          this.$router.push("/")
        })
        .catch(error => {
          this.formErrors = error.response.data
          this.isWaitingForResponse = false
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.container.fill-height > .row {
  max-width: none;
}
</style>
